import { ApiClient } from "./ApiClient"

const validateUser = async () => {
  return ApiClient.post({
    url: "/api/app/account/validateUser"
  });
}

const signIn = async (email, password, token) => {
  return ApiClient.post({
    url: "/api/app/account/signin",
    body: {
      email: email,
      password: password,
      token: token
    }
  });
}

const signOut = async () => {
  return ApiClient.post({
    url: "/api/app/account/signout"
  });
}

const changePassword = async (email, oldpassword, password, confirmpassword, token) => {
  return ApiClient.post({
    url: "/api/app/account/changepassword",
    body: {
      email: email,
      oldpassword: oldpassword,
      password: password,
      confirmpassword: confirmpassword,
      token: token
    }
  });
}

const forgotPassword = async (email, token) => {
  return ApiClient.post({
    url: "/api/app/account/forgotpassword",
    body: {
      email: email,
      token: token
    }
  })
}

const resetPassword = async (code, password, token) => {
  return ApiClient.post({
    url: "/api/app/account/resetpassword",
    body: {
      code: code,
      password: password,
      token: token
    }
  })
}

const checkResetPassword = async (code, token) => {
  return ApiClient.post({
    url: "/api/app/account/checkresetpassword",
    body: {
      code: code,
      token: token
    }
  })
}

const register = async (email, department, password, confirmpassword) => {
  return ApiClient.post({
    url: "/api/app/account/register",
    body: {
      email: email,
      department: department,
      password: password,
      confirmpassword: confirmpassword
    }
  });
}

export const Auth = {
  validateUser: validateUser,
  signIn: signIn,
  signOut: signOut,
  changePassword: changePassword,
  resetPassword: resetPassword,
  forgotPassword: forgotPassword,
  checkResetPassword: checkResetPassword,
  register: register,
};